export enum D365AgentType {
    Agent = 100000000,
    Backoffice = 100000001,
    //Internal
    TeamLeader = 100000002,
}
